import React, {Fragment, useState} from "react";
import {useSelector} from "react-redux";
import Button from "../../../../components/Button";
import {getSensorsLabelValue} from "../../../../redux/Selectors/controllers.selectors";
import DownloadSensorAnalysis from "./downloadSensorAnalysis";

const DownloadAllCSV = () => {
  const sensors = useSelector(getSensorsLabelValue);
  const [count, setCount] = useState(0);

  return (
    <Fragment>
      {sensors.length > 0 && (
        <Fragment>
          <div className="advance-form-heading">Download CSV</div>
          <div className="advance-tab-form-container">
            {sensors.map((sensor) => {
              return (
                <DownloadSensorAnalysis
                  key={sensor.value}
                  count={count}
                  name={sensor.label}
                  id={sensor.value}
                />
              );
            })}
            <div style={{display: "flex", justifyContent: "end"}}>
              <Button onClick={() => setCount((prevCount) => prevCount + 1)}>
                Download All
              </Button>
            </div>
          </div>
        </Fragment>
      )}
    </Fragment>
  );
};

export default DownloadAllCSV;
